import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { toolAllowed, toolMarkedOff, type LicenseState } from '@/lib/licenseGate'

export const useLicenseStore = defineStore('license', () => {
  const state = ref<LicenseState | null>(null)
  const loadedToken = ref('')

  async function ensureLoaded() {
    const token = localStorage.getItem('token') || ''
    if (!token) {
      state.value = null
      loadedToken.value = ''
      return
    }
    if (loadedToken.value === token && state.value) return
    const response = await axios.get<LicenseState>('/instance/license')
    state.value = response.data
    loadedToken.value = token
  }

  function clear() {
    state.value = null
    loadedToken.value = ''
  }

  async function saveExtension(extensionOn: string | null) {
    const response = await axios.put<LicenseState>('/instance/license/extension', {
      extension_on: extensionOn,
    })
    state.value = response.data
    return response.data
  }

  async function saveComponent(tool: string, active: boolean) {
    const response = await axios.put<LicenseState>('/instance/license/components', {
      tool,
      active,
    })
    state.value = response.data
    return response.data
  }

  async function resetComponent(tool: string) {
    const response = await axios.put<LicenseState>('/instance/license/components', {
      tool,
      reset: true,
    })
    state.value = response.data
    return response.data
  }

  function moduleAllowed(moduleName: string) {
    return toolAllowed(state.value, moduleName)
  }

  function moduleMarkedOff(moduleName: string) {
    return toolMarkedOff(state.value, moduleName)
  }

  return {
    state,
    ensureLoaded,
    clear,
    saveExtension,
    saveComponent,
    resetComponent,
    moduleAllowed,
    moduleMarkedOff,
  }
})
